'use client';

import Link from 'next/link';
import { cn } from 'src/app/lib/utils/tailwindcss';
import NextImage from 'src/components/_common/NextImage';

import useAdaptiveBackButton from './_hooks/useAdaptiveBackButton';

const AdaptiveBackButton: React.FC = () => {
  const { isVisible, returnUrl, buttonContext } = useAdaptiveBackButton();

  // 버튼이 표시되지 않아야 하는 경우 렌더링하지 않음
  if (!isVisible || !returnUrl || !buttonContext) {
    return null;
  }

  const { logoImage, name, styles } = buttonContext;

  return (
    <div
      className={cn(
        'fixed bottom-5 left-1/2 z-[100] w-full max-w-[480px] -translate-x-1/2 px-5',
        'flex justify-start',
      )}
    >
      <Link
        href={returnUrl}
        style={styles.button}
        className={cn(
          'inline-flex h-12 items-center justify-center gap-1 rounded-3xl px-4 py-2',
        )}
        aria-label="원래 페이지로 돌아가기"
      >
        <div className="h-4 w-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 3L5 8L10 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div>
          <NextImage src={logoImage} width={32} height={32} alt="logo" />
        </div>
        <p style={styles.text} className="text-sm font-medium leading-[18px] text-white">
          {name} 돌아가기
        </p>
      </Link>
    </div>
  );
};

export default AdaptiveBackButton;
